import Cookies from 'js-cookie';
import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

const AUTH_TOKEN_COOKIE = 'authToken';

export const presenceService = {
  async heartbeat(): Promise<void> {
    await apiClient.post(API_ENDPOINTS.PRESENCE.HEARTBEAT);
  },

  async markOffline(): Promise<void> {
    await apiClient.post(API_ENDPOINTS.PRESENCE.OFFLINE);
  },

  /**
   * Fired from pagehide. sendBeacon survives the tab closing and cannot set
   * an Authorization header, so the JWT travels in the form body.
   */
  markOfflineOnUnload(): void {
    const token = Cookies.get(AUTH_TOKEN_COOKIE);
    if (!token || typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return;
    const base = process.env.REACT_APP_BASE_URL ?? '';
    const body = new URLSearchParams();
    body.set('token', token);
    navigator.sendBeacon(`${base}${API_ENDPOINTS.PRESENCE.OFFLINE}`, body);
  },
};
